import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Menu, X } from "lucide-react";
import { useState } from "react";

export const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { label: "Home", to: "/" },
    { label: "Birth Chart", to: "/generate" },
    { label: "Compatibility", to: "/compatibility" },
    { label: "Premium", to: "/premium" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
  ];

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50"
    >
      <nav className="glass-strong mx-auto mt-4 flex max-w-6xl items-center justify-between rounded-full px-5 py-3 sm:px-7">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-gold" strokeWidth={1.5} />
          <span className="font-display text-lg font-medium tracking-tight text-white">
            Cosmic<span className="text-gold-gradient">Blueprint</span>
          </span>
        </Link>

        <div className="hidden items-center gap-6 lg:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className={`relative text-sm transition-colors ${
                location.pathname === l.to ? "text-gold" : "text-zinc-300 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <button
          data-testid="nav-cta-desktop"
          onClick={() => navigate("/generate")}
          className="hidden rounded-full bg-gradient-to-r from-nebula to-gold px-5 py-2 text-sm font-medium text-white transition-transform hover:scale-105 lg:block glow-purple"
        >
          Generate Chart
        </button>

        <button
          data-testid="nav-mobile-toggle"
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="glass-strong mx-auto mt-2 max-w-6xl rounded-2xl p-4 lg:hidden"
        >
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-4 py-3 text-zinc-200 hover:bg-white/5"
            >
              {l.label}
            </Link>
          ))}
        </motion.div>
      )}
    </motion.header>
  );
};

export default Navbar;
